import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      @media (min-width: ", ") {\n        height: ", "; /* Hard coded value accounting for vds ModalDialogWrapper's margin and padding */\n        width: ", ";\n        max-width: 70vw;\n        max-height: 70vh;\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        animation: ", "\n          0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      animation: 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) 0s\n        ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  flex-flow: column nowrap;\n  height: 99.7%;\n  line-height: ", ";\n  min-height: ", ";\n  position: relative;\n  width: 100%;\n  outline: none;\n\n  ", "\n\n    ", "\n\n  ", "\n\n  @media (min-width: ", ") {\n    padding: ", ";\n  }\n\n  padding: ", ";\n\n\n  ", "\n\n  @media (min-width: ", ") {\n    width: ", "\n  }\n\n  ", "\n\n  min-height: ", ";\n\n  ", ";\n\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n  100% {\n    transform: translateY(", "px);\n    opacity: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(", "px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css, keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors, breakpoints } from '@vds-core/theme';
var propTypes = {
  viewport: PropTypes.oneOf(['mobile', 'desktop', 'tablet']),

  /**
   * @ignore
   */
  styleConfig: PropTypes.object,

  /**
   * @ignore
   */
  fullScreenDialog: PropTypes.bool,

  /**
   * @ignore
   * Configures how far the animation slides in/out
   */
  animationDistance: PropTypes.number,

  /**
   * @ignore
   * Object containing colors
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  viewport: 'desktop',
  fullScreenDialog: false,
  animationDistance: -150
};

var modalDialogAnimation = function modalDialogAnimation(y) {
  return keyframes(_templateObject(), y);
};

var fadeOut = function fadeOut(y) {
  return keyframes(_templateObject2(), y);
}; // Desktop if VDS
//    - width = 560, can accept custom width up to 70% viewport
//    - height = 232, can accept custom height up to 70% viewport + padding
//    - *** ModalDialogWrapper - min-content height 136px, max 70% viewport
// Mobile
//    - width/height 100% viewport


function _calcAnimation(animation, animationDistance) {
  if (animation === 'in') {
    return modalDialogAnimation(animationDistance);
  } else {
    return fadeOut(animationDistance);
  }
}
/**
 * @ignore
 */


var ModalDialog = /*#__PURE__*/styled.div.withConfig({
  displayName: "ModalDialog",
  componentId: "sc-1m9nirl-0"
})(_templateObject3(), function (_ref) {
  var colorConfig = _ref.colorConfig;
  return colorConfig.white;
}, calculateRem(16), calculateRem(232), function (_ref2) {
  var showModal = _ref2.showModal;
  return showModal && css(_templateObject4(), function (_ref3) {
    var animationDistance = _ref3.animationDistance;
    return _calcAnimation('in', animationDistance);
  });
}, function (_ref4) {
  var unmounted = _ref4.unmounted;
  return unmounted && css(_templateObject5(), function (_ref5) {
    var animationDistance = _ref5.animationDistance;
    return _calcAnimation('out', animationDistance);
  });
}, function (_ref6) {
  var viewport = _ref6.viewport,
      modalHeight = _ref6.modalHeight,
      modalWidth = _ref6.modalWidth,
      fullScreenDialog = _ref6.fullScreenDialog,
      styleConfig = _ref6.styleConfig;
  return viewport !== 'mobile' && !fullScreenDialog && css(_templateObject6(), breakpoints.md, function (_ref7) {
    var modalHeight = _ref7.modalHeight;
    return modalHeight ? "".concat(modalHeight + 96, "px") : "auto";
  }, modalWidth || calculateRem(546));
}, breakpoints.md, function (_ref8) {
  var styleConfig = _ref8.styleConfig;
  return styleConfig && styleConfig.calcPadding && styleConfig.calcPadding('desktop');
}, function (_ref9) {
  var styleConfig = _ref9.styleConfig,
      viewport = _ref9.viewport;
  return styleConfig && styleConfig.calcPadding && styleConfig.calcPadding(viewport);
}, function (_ref10) {
  var styleConfig = _ref10.styleConfig;
  return styleConfig && styleConfig.mobileHeight && styleConfig.calcPadding && "\n  @media (max-width: ".concat(breakpoints.md, ") {\n    padding: ").concat(styleConfig.calcPadding('mobile'), ";\n  }\n  ");
}, breakpoints.md, function (_ref11) {
  var styleConfig = _ref11.styleConfig,
      viewport = _ref11.viewport,
      fullScreenDialog = _ref11.fullScreenDialog;
  return !fullScreenDialog && styleConfig && styleConfig.modalWidth;
}, function (_ref12) {
  var fullScreenDialog = _ref12.fullScreenDialog;
  return fullScreenDialog && "\n    height: 100vh !important;\n    width: 100vw !important;\n    max-width: 100vw;\n    max-height: 100vh;\n  ";
}, function (_ref13) {
  var styleConfig = _ref13.styleConfig,
      viewport = _ref13.viewport;
  return viewport === 'mobile' && styleConfig && styleConfig.minHeight;
}, function (_ref14) {
  var styleConfig = _ref14.styleConfig;
  return styleConfig && styleConfig.minHeight && "\n  @media (max-width: ".concat(breakpoints.md, ") {\n    min-height: ").concat(styleConfig.minHeight, ";\n  }\n  ");
}); //padding is 16/48 for VDS

ModalDialog.propTypes = propTypes;
ModalDialog.defaultProps = defaultProps;
export default ModalDialog;